import get from "lodash-es/get";
import { makeSoccerAbbreviation } from "shared/src/utils/soccerAbbreviation";
import { getTeamInfo } from "shared/src/hooks/getTeamInfo";
import { normalizeSport } from "shared/src/utils/sportMap";

export const transformMarketHeader = ({ markets, marketHeader, sport: _sportRaw, league, competitionType, hasMultipleCompetitors = false }) => {
    const _sport = normalizeSport(_sportRaw);
    if (_sport === "football" && hasMultipleCompetitors) {
        const _home =
          get(markets, "[0].competitors[0].team", null) ||
          get(markets, "[0].competitors[0].displayName", null);
        const _away =
          get(markets, "[0].competitors[1].team", null) ||
          get(markets, "[0].competitors[1].displayName", null);
        
        // Get Team Info
        const limitTo = competitionType || league 
          ? { limitTo: [competitionType ? competitionType : league] } 
          : undefined;
        const homeTeamInfo = getTeamInfo(_home, limitTo);
        const awayTeamInfo = getTeamInfo(_away, limitTo);

        const home =
          homeTeamInfo?.abbreviation || makeSoccerAbbreviation(_home);
        const away =
          awayTeamInfo?.abbreviation || makeSoccerAbbreviation(_away);
          return {
            ...marketHeader,
            labels: [home, "Draw", away]
          };
    }
    return marketHeader ;
}